import { render, staticRenderFns } from "./GerenciarUsuarioRoute.vue?vue&type=template&id=c3e00a36"
import script from "./GerenciarUsuarioRoute.vue?vue&type=script&lang=js"
export * from "./GerenciarUsuarioRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports